module.exports = __webpack_public_path__ + "static/media/context.5898d100.md";